import { useEffect } from 'react';
import { useAuth } from '@/hooks/useAuth';

/**
 * Hook para preload inteligente baseado em contexto do usuário
 * Otimizado para iniciar mais cedo e priorizar chunks críticos
 */
export const usePreloadPages = () => {
  const { user } = useAuth();

  useEffect(() => {
    // Preload dashboard IMEDIATAMENTE após login
    if (user) {
      // Sem timeout - executa imediatamente
      Promise.all([
        import('@/pages/Home'),
        import('@/pages/Dashboard'),
        import('@/pages/Perfil'),
      ]);
    }
  }, [user]);

  useEffect(() => {
    // Preload admin pages IMEDIATAMENTE para admins
    if (user?.user_metadata?.role === 'admin') {
      import('@/pages/admin/GestaoServicos');
    }
  }, [user?.user_metadata?.role]);

  // Preload de páginas secundárias em idle time
  useEffect(() => {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(() => {
        // Preload de páginas comuns em background
        if (user) {
          Promise.all([
            import('@/pages/MeusProdutos'),
            import('@/pages/Historico'),
          ]);
        }
      });
    }
  }, [user]);
};